// extracted by mini-css-extract-plugin
export default {"custom_dialog":"TagRemovePopup_custom_dialog__AITbW","custom_dialog_close":"TagRemovePopup_custom_dialog_close__ToyJK","removeButton":"TagRemovePopup_removeButton__47zsB"};